const Overlay = ({
    children,
    isOverlayOpen,
    className,
    overlayRef,
}: {
    isOverlayOpen: boolean
    children: React.ReactElement
    className?: string
    overlayRef?: React.RefObject<HTMLDivElement>
}) => {
    const mobileClass = ' sm:w-auto'

    return (
        <div
            ref={overlayRef ? overlayRef : null}
            className={`${className} overlay box-shadow fixed border rounded-logistical-radius mt-1 w-[400px] transition-all ease-out themes-bg-white z-[1] right-[30px] ${mobileClass} ${isOverlayOpen ? '' : 'hidden'}`}
        >
            {children}
        </div>
    )
}

export default Overlay
